import { BasicNode, BasicNodeProps } from "./BasicNode";

const CompletedNode = (props: BasicNodeProps) => (
  <BasicNode {...props} className="border-green-500 bg-green-100" />
);

export default CompletedNode;
